<template>
    <div class="mini_wrap">
      <swiper class="swiper-no-swiping" id="swiper" :options="swiperOption">
        <swiper-slide :class="(data.id==resourceId?'swiper_active':'')+((resourceData.length>5)&&index==(resourceData.length-1)?' last_swiper':'')" v-for="(data,index) in resourceData" :key="data.id" >
          <div style="width: 100%;height: 100%;" @click="selectCurrent(data,index)">
            <div class="resource_tag" v-if="data.type == 1">
              <i class="pic"></i>
              <span>图片</span>
              <img v-if="data.taskType === 1 && sign!='preview'" :src="data.isFinish === 1?isFinish:unFinish"/>
            </div>
            <div class="resource_tag" v-if="data.type == 2 || data.type == 5">
              <i class="file"></i>
              <span>文件</span>
              <img v-if="data.taskType === 1 && sign!='preview'" :src="data.isFinish === 1?isFinish:unFinish"/>
            </div>
            <div class="resource_tag" v-if="data.type == 3">
              <i class="audio"></i>
              <span>音频</span>
              <img v-if="data.taskType === 1 && sign!='preview'" :src="data.isFinish === 1?isFinish:unFinish"/>
            </div>
            <div class="resource_tag" v-if="data.type == 4">
              <i class="video"></i>
              <span>视频</span>
              <img v-if="data.taskType === 1 && sign!='preview'" :src="data.isFinish === 1?isFinish:unFinish"/>
            </div>
            <div class="resource_tag" v-if="data.resourceType == 3">
              <i class="shiti"></i>
              <span>实训题</span>
              <img v-if="data.taskType === 1 && sign!='preview'" :src="data.isFinish === 1?isFinish:unFinish"/>
            </div>
            <div class="resource_tag" v-if="data.resourceType == 5">
              <i class="test"></i>
              <span>测验</span>
              <img v-if="data.taskType === 1 && sign!='preview'" :src="data.isFinish === 1?isFinish:unFinish"/>
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-button-prev" slot="button-prev"><i class="el-icon-arrow-left"></i></div>
        <div class="swiper-button-next" slot="button-next"><i class="el-icon-arrow-right"></i></div>
      </swiper>
      <div v-if="!isShowNote" @click="switchRight" class="switch_btn">
        <img :src="switchPic" alt="">
      </div>
    </div>
</template>

<script>
    import switchPic from "../../../../static/images/study/icon/switch_transverse.png";
    import {mapState, mapMutations, mapActions, mapGetters} from 'vuex';
    import {moduleId} from "../../../store/modules/courseDetail";
    import isFinishSrc from "../../../../static/images/study/icon/success.png"
    import unFinishSrc from "../../../../static/images/study/icon/unfinished.png"
    import {getQuery2object} from "@/utils/utils"
    export default {
        name: "miniSwiper",
        data(){
            return{
                switchPic:switchPic,
                swiperOption: {
                    // width: 160,
                    slidesPerView: "auto",
                    // spaceBetween: 30,
                    // slidesPerGroup: 1,
                    loop: false,
                    loopFillGroupWithBlank: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                },
                isFinish: isFinishSrc,
                unFinish: unFinishSrc
            }
        },
        props: {
          sign: {
            type: String,
            default: ''
          }
        },
        computed:{
            ...mapState(moduleId, {
                resourceData: state => state.resourceData,
                swiperFlag:state => state.swiperFlag,
                resourceId:state => state.resourceId,
                isShowNote:state => state.isShowNote,
            }),
        },
        created(){
        	if(this.type == 3){
        		this.swiperFlag = false;
        	}
        },
        methods:{
            ...mapActions(moduleId,[
                "setSwiperFlag",
                "setCurrentResource",
                "setResourceId"
            ]),
            selectCurrent(data, index){
              this.setResourceId(data.id);
              this.setCurrentResource({...data,index});
              this.$emit('getActiveIndex', index);
							let query = this.$router.history.current.query
							let path = this.$router.history.current.path
							let newQuery = JSON.parse(JSON.stringify(query));
							newQuery.childred = data.id;
							this.$router.push({ path, query: newQuery });
            },
            switchRight(){
                this.setSwiperFlag(!this.swiperFlag);
            }
        }
    }
</script>

<style lang="scss" scoped>
.mini_wrap{
  width: 100%;
  height: 32px;
  display: flex;
  #swiper{
    width: 100%;
    height: 100%;
    border:1px solid rgba(234,234,234,1);
    box-sizing: border-box;
    .swiper-slide{
      width: 160px !important;
      border-right:1px solid #5397F7;
      line-height: 32px;
      text-align: center;
      box-sizing: border-box;
      cursor: pointer;
      background: #E8F2FF;
      &:first-child{
        width: 192px !important;
        padding-left: 32px;
      }
      .resource_tag{
        display: flex;
        align-items: center;
        justify-content: center;
        i{ width: 16px; height: 16px; }
        .pic{ background:url('../../../../static/images/study/icon/pic.png') no-repeat; background-size: 16px 16px; }
        .file{ background:url('../../../../static/images/study/icon/file.png') no-repeat; background-size: 16px 16px; }
        .audio{ background:url('../../../../static/images/study/icon/audio.png') no-repeat; background-size: 16px 16px; }
        .video{ background:url('../../../../static/images/study/icon/video.png') no-repeat; background-size: 16px 16px; }
        .shiti{ background:url('../../../../static/images/study/icon/shiti.png') no-repeat; background-size: 16px 16px; }
        .test{ background:url('./img/testBg.png') no-repeat; background-size: 16px 16px; }
        span{ color:#5397F7; margin: 0 4px; font-size: 12px;}
        img{
          width: 12px;
          height: 12px;
        }
      }
      &:hover{
        background:rgba(237,244,255,1);
      }
    }
    .last_swiper{
      width: 192px !important;
      padding-right: 32px;
    }
    .swiper-button-prev,.swiper-button-next{
      width: 32px;
      height: 32px;
      line-height: 32px;
      background: rgba(2255,255,255,1);
      text-align: center;
      font-size: 20px;
      top: 0;
      margin: 0;
      &:hover{
        background: #EDF4FF;
      }
      i{
        color: #5397F7;
      }
      &::after{
        content: '';
      }
    }
    .swiper-button-prev{
      left: 0;
    }
    .swiper-button-next{
      right: 0;
    }
    .swiper-button-disabled{
      opacity: 1;
      i{
        color: #999;
      }
    }
    .swiper_active{
      background: #3EB1ED;
      pointer-events: none;
      .resource_tag{
        .pic{ background:url('../../../../static/images/study/icon/pic_hv.png') no-repeat; background-size: 16px 16px; }
        .file{ background:url('../../../../static/images/study/icon/file_hv.png') no-repeat; background-size: 16px 16px; }
        .audio{ background:url('../../../../static/images/study/icon/audio_hv.png') no-repeat; background-size: 16px 16px; }
        .video{ background:url('../../../../static/images/study/icon/video_hv.png') no-repeat; background-size: 16px 16px; }
        .shiti{ background:url('../../../../static/images/study/icon/shiti_hv.png') no-repeat; background-size: 16px 16px; }
        .test{ background:url('../../../../static/images/study/icon/shiti_hv.png') no-repeat; background-size: 16px 16px; }
        span{ color:#fff;}
      }
    }
  }
  .switch_btn{
    width: 35px;
    height: 32px;
    cursor: pointer;
    img{
      width: 18px;
      height: 18px;
      display: block;
      margin: 6px auto 0;
    }
    border-bottom: 1px solid rgba(234,234,234,1);
    border-top: 1px solid rgba(234,234,234,1);
    box-sizing: border-box;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/subcomponent/miniSwiper/miniSwiper.vue